let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jE6NT")).then(() => parcelRequire('2yLDN'));